/* eslint-disable import/prefer-default-export */
// import { getEnvironmentFromUrl } from './helpers';

const baseUrl = process?.env?.REACT_APP_LOCAL_BASE_URL || `https://${window.location.host}`;

// const environment = getEnvironmentFromUrl();

const hapAPIURL = process?.env?.REACT_APP_LOCAL_API_URL || `${baseUrl}/api`;
const redirectUri = `${baseUrl}/api/auth/login`;

const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;
const b2cEndpoint = process.env.REACT_APP_B2C_ENDPOINT;
const b2cPolicy = process.env.REACT_APP_B2C_POLICY;
const assignmentsUploadFolder = process.env.REACT_APP_ASSIGNMENTS_UPLOAD_FOLDER;
const uniformsUploadFolder = process.env.REACT_APP_UNIFORMS_UPLOAD_FOLDER;

export {
  clientId,
  tenantId,
  b2cPolicy,
  b2cEndpoint,
  hapAPIURL,
  redirectUri,
  assignmentsUploadFolder,
  uniformsUploadFolder,
};
